import React from 'react';
import './ModernFooter.css';

export const ModernFooter: React.FC = () => {
	const currentYear = new Date().getFullYear();

	return ( <footer className="modern-footer">
			<div className="footer-gradient"></div>
			<div className="container footer-container">
				<div className="footer-content">
					<div className="footer-brand">
						<img src="/ew-color-logo_crop.png" alt="EquityWorkx" className="footer-logo"/>
						<p className="footer-tagline">
							Transform your mortgage into millions with proven wealth building strategies.
						</p>
					</div>

					<div className="footer-links">
					<div className="footer-column">
						<h3 className="footer-heading">Product</h3>
						<ul className="footer-list">
							<li><a href="/features">Features</a></li>
							<li><a href="/how-it-works">How It Works</a></li>
							<li><a href="/download">Download App</a></li>
						</ul>
					</div>

					<div className="footer-column">
						<h3 className="footer-heading">Company</h3>
						<ul className="footer-list">
							<li><a href="/about">About Us</a></li>
							<li><a href="/contact">Contact</a></li>
						</ul>
					</div>

					<div className="footer-column">
						<h3 className="footer-heading">Legal</h3>
						<ul className="footer-list">
							<li><a href="/privacy">Privacy Policy</a></li>
							<li><a href="/terms">Terms of Service</a></li>
						</ul>
					</div>
					</div>
				</div>

				<div className="footer-bottom">
					<div className="footer-bottom-content">
						<p className="copyright">
							© { currentYear } EquityWorkx. All rights reserved.
						</p>
					</div>
				</div>
			</div>
		</footer> );
};
